import { render, staticRenderFns } from "./TranslationRequests.vue?vue&type=template&id=a3c7f050&scoped=true"
import script from "./TranslationRequests.vue?vue&type=script&lang=js"
export * from "./TranslationRequests.vue?vue&type=script&lang=js"
import style0 from "./TranslationRequests.vue?vue&type=style&index=0&id=a3c7f050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c7f050",
  null
  
)

export default component.exports